import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "stepTwo",
    "stepThree",
    "nextButton",
    "previousButton",
    "submitButton",
    "accordionItem",
    "accordionContent",
    "subjectRadio",
    "stepCircle",
    "stepLine",
    "stepLineActive"
  ]

  connect() {
    this.currentStep = 2 // Start at step 2 as step 1 is the classroom selection
    this.totalSteps = 3
    this.showCurrentStep()
    this.updateStepper()
    this.updateButtonVisibility()
  }

  nextStep() {
    if (this.currentStep < this.totalSteps) {
      if (this.isStepValid(this.currentStep)) {
        this.currentStep++
        this.showCurrentStep()
        this.updateStepper()
        this.updateButtonVisibility()
      }
    }
  }

  previousStep() {
    if (this.currentStep > 2) { // Can't go back from step 2
      this.currentStep--
      this.showCurrentStep()
      this.updateStepper()
      this.updateButtonVisibility()
    }
  }

  showCurrentStep() {
    this.stepTwoTarget.style.display = this.currentStep === 2 ? "block" : "none"
    this.stepThreeTarget.style.display = this.currentStep === 3 ? "block" : "none"
  }

  updateStepper() {
    this.stepCircleTargets.forEach((circle, index) => {
      const stepIndex = parseInt(circle.dataset.stepIndex)
      const activeCircle = circle.nextElementSibling

      if (stepIndex < this.currentStep) {
        // Completed step
        circle.classList.add('hidden')
        activeCircle.classList.remove('hidden')
      } else if (stepIndex === this.currentStep) {
        // Current step
        circle.classList.remove('hidden')
        activeCircle.classList.add('hidden')
        circle.classList.remove('border-gray-300', 'bg-white', 'text-gray-400')
        circle.classList.add('border-blue-500', 'bg-blue-50', 'text-blue-600')
      } else {
        // Future step
        circle.classList.remove('hidden')
        activeCircle.classList.add('hidden')
        circle.classList.remove('border-blue-500', 'bg-blue-50', 'text-blue-600')
        circle.classList.add('border-gray-300', 'bg-white', 'text-gray-400')
      }
    })

    this.stepLineActiveTargets.forEach((line) => {
        const stepIndex = parseInt(line.dataset.stepIndex)
        if (stepIndex < this.currentStep) {
            line.classList.remove('hidden')
        } else {
            line.classList.add('hidden')
        }
    })
  }

  updateButtonVisibility() {
    this.previousButtonTarget.style.display = this.currentStep > 2 ? "inline-flex" : "none"
    this.nextButtonTarget.style.display = this.currentStep < this.totalSteps ? "inline-flex" : "none"
    this.submitButtonTarget.style.display = this.currentStep === this.totalSteps ? "inline-flex" : "none"
  }

  isStepValid(step) {
    if (step === 2) {
      const selectedCourse = this.subjectRadioTargets.some(radio => radio.checked)
      if (!selectedCourse) {
        // You can add a flash message here if you want
        alert("Veuillez sélectionner une matière.")
        return false
      }
    }
    return true
  }

  toggleAccordion(event) {
    const item = event.currentTarget
    const content = item.nextElementSibling
    const icon = item.querySelector('svg')

    if (content.style.maxHeight) {
      content.style.maxHeight = null
      icon.classList.remove('rotate-180')
    } else {
      content.style.maxHeight = content.scrollHeight + "px"
      icon.classList.add('rotate-180')
    }
  }
}